<section
    class="flex justify-center text-center p-4 md:p-8"
    [class.min-h-screen]="centered()"
    [class.items-center]="centered()"
    [class.pt-16]="!centered()">
    <div class="max-w-3xl text-center flex flex-col items-center gap-6">
        <h1>{{ title() }}</h1>
        @if (message()) {
            <p>{{ message() }}</p>
        }
        <ng-content />
    </div>
</section>
